import classNames from "classnames";
import navRightArrowLight from "assets/nav-right-arrow.svg";
import navRightArrowDark from "assets/nav-right-arrow-dark.svg";
import navRightArrowDisabledLight from "assets/nav-right-arrow-disabled-light.svg";
import navRightArrowDisabledDark from "assets/nav-right-arrow-disabled-dark.svg";
import "./index.scss";

interface IProps {
  theme?: "light" | "dark";
  style?: string;
  onClick?: () => void;
  isDisable?: boolean;
}

export const NavRightArrow = ({ theme, style, onClick, isDisable }: IProps) => {
  const src =
    isDisable
      ? theme === "dark"
        ? navRightArrowDisabledDark
        : navRightArrowDisabledLight
      : theme === "dark"
        ? navRightArrowDark
        : navRightArrowLight;

  return (
    <div
      onClick={onClick}
      className={classNames({ [`${style}`]: true }, "arrow")}
    >
      <img src={src} alt="" width={10} height={16} />
    </div>
  );
};
